import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { Subscription } from '../../util/rxjs';
import { calculatePasswordStrength } from '../validators/passwordValidator';

@Component({
  selector: 'cp-password-strength',
  templateUrl: './password-strength.component.html',
  styleUrls: ['./password-strength.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordStrengthComponent implements OnDestroy, OnInit {
  @Input()
  passwordControl: UntypedFormControl;

  @Input()
  validate = true;

  strength = 0;
  get isStrongPassword() {
    return this.strength >= 3;
  }

  get password$() {
    return this.passwordControl.valueChanges;
  }

  private passwordStrengthSubscription: Subscription;

  points = [
    'rgb(255, 0,   0)',
    'rgb(255, 153, 0)',
    'rgb(255, 255, 0)',
    'rgb(153, 255, 0)',
    'rgb(0,   255, 0)'
  ];

  ngOnInit() {
    this.passwordStrengthSubscription = this.passwordControl.valueChanges
      .subscribe(value => {
        this.strength = calculatePasswordStrength(value);
      });
  }

  ngOnDestroy() {
    if (this.passwordStrengthSubscription) {
      this.passwordStrengthSubscription.unsubscribe();
    }
  }

  getColorFor(index: number, password: string) {
    const strength = calculatePasswordStrength(password);
    if (strength >= (index + 1)) {
      return this.points[strength - 1];
    }
    return 'rgb(221, 221, 221)';
  }
}
